import { useNavigate } from "react-router-dom";
import { FormEvent, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Container } from "@mui/material";

import Back from "../utils/Back";
import LOGO from "../../semiauth.logo.png";
import { useAuth } from "./AuthProvider";
import TermsAndConditions from "../utils/TermsAndConditions";
import { useVaultLocalSignup } from "../../hooks/vault/base";

const SignupLocal = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  const [agreed, setAgreed] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [emailConfirmation, setEmailConfirmation] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>("");

  const signup = useVaultLocalSignup();

  const disableSubmit =
    !firstName ||
    !lastName ||
    !email ||
    !emailConfirmation ||
    !password ||
    !passwordConfirmation ||
    !agreed;

  const handleAgreed = (e) => setAgreed(e.target.checked);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // attempt sign up
    signup.mutate({
      lastName,
      firstName,
      email,
      emailConfirmation,
      password,
      passwordConfirmation,
    });
  };

  useEffect(() => {
    if (auth) navigate("/");
  }, [auth]);

  useEffect(() => {
    document.title = "[semiauth] | local | signup";
  }, []); // run once on mount

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        marginBlock: "auto",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={LOGO} alt="[semiauth] logo" className="logo" />

        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="given-name"
                name="firstName"
                required
                fullWidth
                id="firstName"
                label="First name"
                autoFocus
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="lastName"
                label="Last name"
                name="lastName"
                autoComplete="family-name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email-confirmation"
                name="email-confirmation"
                label="Confirm email"
                autoComplete="email-confirmation"
                value={emailConfirmation}
                onChange={(e) => setEmailConfirmation(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="password"
                name="password"
                label="Password"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="confirmation"
                name="confirmation"
                label="Confirm password"
                type="password"
                autoComplete="password-confirmation"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} textAlign="left">
              <TermsAndConditions
                type="platform"
                agreed={agreed}
                handleAgreed={handleAgreed}
              />
            </Grid>
          </Grid>

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={disableSubmit}
            sx={{ mt: 3, mb: 2 }}
          >
            Sign up
          </Button>

          <Grid container justifyContent="flex-start">
            <Grid item>
              <Back />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};
export default SignupLocal;
